import Vue from 'vue';
import { guid } from '@/mixins/guid';
import { modals } from '@/mixins/modal';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-product-feature', {
  template: require('./template.html'),
  name: 'edit-product-feature',
  mixins: [guid, modals, uploader],
  components: {
    uploadProgress,
    linkDynamic,
  },
  props: ['droplet', 'show-edit-bubble', 'profile', 'product'],
  data() {
    return {
      activeItem: null,
      loading: false,
      imgLimit: 1,
      itemLimit: 4,
      display: {
        btnText: '',
        zoom: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
    'display.zoom': function bounceOnZoom() {
      this.bouncePlugin();
    },
  },
  methods: {
    setInitialValues() {
      this.display.btnText = this.droplet.btnText;
      this.display.zoom = this.droplet.zoom;
    },
    bouncePlugin() {
      this.$vnode.context.destroyPlugin();
      this.$vnode.context.initPlugin();
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
    async drzRevertData() {
      this.$emit('css-generator');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-feature/components/_edit-options/index.js